(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('BlockedPhoneSearch', BlockedPhoneSearch);

    BlockedPhoneSearch.$inject = ['$resource'];

    function BlockedPhoneSearch($resource) {
        var resourceUrl =  'api/_search/blocked-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
